import { unwrapApiResult } from '@/api/unwrapApiResult'

type ApiResult = { response: Response; error?: unknown }

/**
 * Run a mutation whose success response has no body (e.g. 200/201/204 with
 * `content?: never`). openapi-fetch otherwise tries to JSON-parse the empty
 * body and throws, so the request must use `parseAs: 'text'` — supplied here
 * via the callback param. Asserts only on `response.ok`; errors are still
 * parsed as JSON by openapi-fetch regardless of `parseAs`.
 */
export async function mutateNoBody<R extends ApiResult>(
  call: (parseAs: 'text') => Promise<R>,
  fallbackMessage: string,
): Promise<void> {
  unwrapApiResult(await call('text'), fallbackMessage)
}
